import { Address } from 'types/common'

export const formatAddress = (address: Address) => {
  return [
    address.number,
    address.street,
    address.apartment,
    address.city,
    address.administrativeArea,
    address.postalCode,
    address.country,
  ]
    .filter(Boolean)
    .join(', ')
}
